var _rect, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    rx: 17,
    fill: "#E6FAF4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2304 9.77539H9.3499C8.4064 9.77539 7.6584 10.5319 7.6584 11.4754L7.6499 21.6754C7.6499 22.6189 8.4064 23.3754 9.3499 23.3754H22.9499C23.8934 23.3754 24.6499 22.6189 24.6499 21.6754V18.6864C24.0575 18.6475 23.4872 18.5275 22.9499 18.3376V21.6754H9.3499V16.5754H20.3232C19.4919 15.6466 18.9289 14.4727 18.7561 13.1754H9.3499V11.4754H18.7561C18.8356 10.8787 18.9976 10.3081 19.2304 9.77539Z",
    fill: "#00C489"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.0744 17.0004C27.6563 17.0004 29.7494 14.9073 29.7494 12.3254C29.7494 9.74346 27.6563 7.65039 25.0744 7.65039C22.4925 7.65039 20.3994 9.74346 20.3994 12.3254C20.3994 14.9073 22.4925 17.0004 25.0744 17.0004ZM24.2244 14.8754V13.1754H22.5244V11.4754H24.2244V9.77539H25.9244V11.4754H27.6244V13.1754H25.9244V14.8754H24.2244Z",
    fill: "#00C489"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard);
export default __webpack_public_path__ + "static/media/card.f469cdb0.svg";
export { ForwardRef as ReactComponent };